module.exports = __webpack_public_path__ + "static/media/Niya Shajee.71323367.jpg";